import React, { useEffect } from 'react';
import ClientWelcome from '../dashboard/welcome/ClientWelcome';
import './WelcomePage.css';

export default function ClientWelcomePage({ user }) {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }
    document.body.classList.add('hide-topbar');
    return () => {
      document.body.classList.remove('hide-topbar');
    };
  }, []);

  return (
    <main className="welcome-page">
      <div className="welcome-page__shell">
        <ClientWelcome user={user} />
      </div>
    </main>
  );
}
